<div class="panel-body " *ngIf="(probationCondition===undefined 
|| (probationCondition!==undefined && probationCondition.isPrbnDataPresent() === false))">
	<div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
			<div class="panel-title">
				Probation Conditions
			</div>
			<div class="panel-body ">
				No Probation Conditions information available for this allegation.
			</div>
	</div>
</div>
<!-- <div class="panel-body " *ngIf="probationCondition===undefined">
  No Probation Conditions information available for this allegation.
</div> -->
<div class="panel-body " *ngIf="(probationCondition!==undefined && probationCondition.isPrbnDataPresent() !== false)">
    <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
      <div class="panel-title">
        Probation Conditions
      </div>
     <div class="panel-body ">
        <div class="col-md-6 panel panel-default panel-margin-bottom panel-margin-top" *ngIf="probationCondition.getParents().length !==0">
            <div class="panel-title">
              Parent/Guardian/Custodian Assigned
            </div>
            <div class="panel-body" *ngFor="let parent of probationCondition.getParents(); let al = index">
              {{parent.getPartyName()+ ' (' + parent.getRelationship() + ')'}}
            </div>
        </div>
        <div class="col-sm-12 panel panel-default panel-margin-bottom panel-margin-top">
            <div class="panel panel-default" *ngIf="probationCondition.getOtherAllegations().length !=0">
                <div class="panel-title">
                  Other Allegations Included On Order
                </div>
                <div class="panel-body" >
                    <div class="row table-responsive">
                        <table id="allegations-table" class="table table-condensed table-striped">
                            <thead>
                                <tr>
                                    <th id="V122c">
                                      <span class="field-code ">V122c json='allegations.pleadingType'</span>
                                      Pleading Type <br> 
                                      <span class="field-code ">V122c json='allegations.clockDate'</span>
                                      And Clock Date
                                    </th>
                                    <th id="V121c">
                                      <span class="field-code ">V121c json='allegations.allegation'</span>
                                        Allegation <br>
                                        <span class="field-code ">V121c json='allegations.offenseDate'</span>
                                        Offense Date
                                      </th>
                                     </tr>
                            </thead>
                            <tbody  *ngFor="let otherAllegation of probationCondition.getOtherAllegations()let i = index;">                            
                                 <tr >
                                  <td id="{{'juvenile-caseDetails-probationCondition-' + i + '-pleadingType'}}">
                                    {{otherAllegation.getOtherPleadingTypeDesc()}} <br>
                                    {{otherAllegation.getOtherPleadingDate() | date:'MM/dd/yyyy'}} {{otherAllegation.getOtherPleadingTime()}}</td>
                                  <td id="{{'juvenile-caseDetails-probationCondition-' + i + '-allegationDescription'}}">
                                    {{otherAllegation.getOtherAllegationDescription()}} <br>        
                                    {{otherAllegation.getOtherAllegationOffenseDate() | date:'MM/dd/yyyy'}}</td>
                                </tr>    
                               </tbody>
                        </table>
                    </div>
                </div>
                </div>
            <div class="panel panel-default" *ngIf="probationCondition.isConditionsDetailsPresent() === true">
            <div class="panel-title">
              Conditions
            </div>
            <div class="panel-body">
              <B>The Court orders the juvenile, as conditions of probation to: </B>
              <ul style="list-style-type:disc">
                <div *ngIf="probationCondition.getGoodBehaviour() === 'Y'" >
                  <li>Remain on good behavior and not violate any laws</li>
                </div>
                <div *ngIf="probationCondition.getNotViolate() === 'Y'" >
                  <li> Not violate any reasonable and lawful rules of the juvenile's parent, guardian, or custodian </li>
                </div>
                <div *ngIf="probationCondition.getAttendSchool() === 'Y'" >
                  <li>Attend school regularly</li>
                </div>
                <div *ngIf="probationCondition.getMaintainPassingGrades() === 'Y'" >
                  <li>Maintain passing grades in at least {{probationCondition.getNumberOfCourses()}} courses</li>
                </div>
                <div *ngIf="probationCondition.getNotAssociateWithPersons() === 'Y'" >
                  <li>Not associate with</li>
                  <span *ngIf="probationCondition.getNotAssociatePersonsList() !== ''">
                  <ul style="list-style-type:disc">
                    <li>{{probationCondition.getNotAssociatePersonsList()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="probationCondition.getNotInPlaces() === 'Y'" >
                  <li>Not be in the following place(s)</li>
                  <span *ngIf="probationCondition.getNotInPlacesList() !== ''">
                  <ul style="list-style-type:disc">
                    <li>{{probationCondition.getNotInPlacesList()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="probationCondition.getNotPossesControlledSubstance() === 'Y'" >
                  <li>Not use or possess any controlled substance</li>
                </div>
                <div *ngIf="probationCondition.getNotPossesAlcohol() === 'Y'" >
                  <li>Not use or possess any alcoholic beverage</li>
                </div>
                <div *ngIf="probationCondition.getRandomTesting() === 'Y'" >
                  <li>Submit to random drug testing</li>
                </div>
                <div *ngIf="probationCondition.getCurfew() === 'Y'" >
                  <li>Abide by the following curfew</li>
                  <span *ngIf="probationCondition.getCurfewConditions() !== ''">
                  <ul style="list-style-type:disc">
                    <li>{{probationCondition.getCurfewConditions()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="probationCondition.getWarrentLessSearch() === 'Y'" >
                  <li>Submit to a warrantless search at reasonable times</li>
                  <span *ngIf="probationCondition.getWarrentLessSearchConditions() !== ''">
                  <ul style="list-style-type:disc">
                    <li>{{probationCondition.getWarrentLessSearchConditions()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="probationCondition.getNoFirearm() === 'Y'" >
                  <li>Possess no firearm, explosive device or other deadly weapon</li>
                </div>
                <div *ngIf="probationCondition.getReportToCounselor() === 'Y'" >
                  <li>Report to Court Counselor as often as required by the Court Counselor</li>
                </div>
                <div *ngIf="probationCondition.getPayRestitution() === 'Y'" >
                  <li>Pay restitution into the office of the Clerk of Superior Court as follows</li>
                  <span *ngIf="probationCondition.getPayRestitutionConditions() !== ''">
                  <ul style="list-style-type:disc">
                    <li>{{probationCondition.getPayRestitutionConditions()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="probationCondition.getPayFine() === 'Y'" >
                  <li>Pay fine into the office of the Clerk of Superior Court as follows</li>
                  <span *ngIf="probationCondition.getPayFineConditions() !== ''">
                  <ul style="list-style-type:disc">
                    <li>{{probationCondition.getPayFineConditions()}}</li>
                  </ul></span>
                </div>
                <div *ngIf="probationCondition.getBeEmployed() === 'Y'" >
                  <li>Be employed regularly if not attending school</li>
                </div>
                <div *ngIf="probationCondition.getOther() === 'Y'" >
                  <li>Other</li>
                  <span *ngIf="probationCondition.getOtherConditions() !== ''">
                  <ul style="list-style-type:disc">
                    <li>{{probationCondition.getOtherConditions()}}</li>
                  </ul></span>
                </div>
              </ul>
            </div>
            </div>
            <div class="panel panel-default" *ngIf="probationCondition.isOrderDetailsPresent() === true">
            <div class="panel-title">
              Order
            </div>
            <div class="panel-body">
              <B>The court FURTHER ORDERS the juvenile, if directed to do so by the chief court counselor, to:</B>
              <ul style="list-style-type:disc">
                <div *ngIf="probationCondition.getCommunityService() === 'Y'" >
                  <li>Perform upto 20 hours of community service</li>
                </div>
                <div *ngIf="probationCondition.getSubstanceAbuseMonitoring() === 'Y'" >
                  <li>Submit to substance abuse monitoring and treatment</li>
                </div>
                <div *ngIf="probationCondition.getLifeSkillsProgram() === 'Y'" >
                  <li>Participate in a life skills or an educational skills program administered by the office of Juvenile Justice</li>
                </div>
                <div *ngIf="probationCondition.getElectronicMonitoring() === 'Y'" >
                  <li>Cooperate with electronic monitoring</li>
                </div>
                <div *ngIf="probationCondition.getIntensiveSupervision() === 'Y'" >
                  <li>Cooperate with intensive supervision</li>
                  <span *ngIf="probationCondition.getProbationTerminationDate() !== ''">
                  <ul style="list-style-type:disc">
                    <li>Probation termination date: {{probationCondition.getProbationTerminationDate()}}</li>
                  </ul></span>
                </div>
              </ul>
            </div>
            </div>   
        </div>
    </div>
   </div>
 </div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/juvenile/allegations/allegations-additional-info/probation-conditions/probation-conditions.component.html